import { render, staticRenderFns } from "./MySubmissionsActions.vue?vue&type=template&id=12d20006"
import script from "./MySubmissionsActions.vue?vue&type=script&lang=js"
export * from "./MySubmissionsActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports